module.exports = __webpack_public_path__ + "img/poster-small.49712a54.png";